import Phase2SchedulerPage, { Phase2SchedulerPageProps } from "./phase-2-scheduler-page";
export type {
    Phase2SchedulerPageProps
}

export default Phase2SchedulerPage;